// Helper to handle negative values for css vars
// Example:
// margin-left: ${negative(`${spacing.L}`)};

export const negative = (val: string): string => `calc(-1 * ${val})`;
